// SignUpSuccess.jsx — Post-registration confirmation page.
//
// Shown after a successful email/password signup. The user is signed out at
// this point (see UserContext.register) so PublicRoute won't redirect them.
//
// Flow: SignUp → register() → navigate(/signup-success) → this page → /login
//
// To change the copy (e.g. trial length, promo name), edit the <h2> and <p>
// below. The green accent colour is var(--bloom-green) (shared with PrimaryButton).
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import AuthHeader from '../components/auth/AuthHeader';
import PrimaryButton from '../components/auth/PrimaryButton';
import { CheckCircle } from 'lucide-react';
import { getLogoutRedirect } from '../utils/logoutRedirect';

const PageTitle = ({ title }) => {
  React.useEffect(() => {
    document.title = title || 'Bloom IQ';
  }, [title]);
  return null;
};

const SignUpSuccess = () => {
  const navigate = useNavigate();

  return (
    <>
      <PageTitle title="Sign Up Successful - Bloom IQ" />
      <AuthLayout variant="light">
        <div className="w-full flex flex-col items-center">
          {/* Logo */}
          <AuthHeader />

          {/* Checkmark */}
          <CheckCircle className="w-16 h-16 text-bloom-green mb-6" />

          {/* Heading */}
          <h2 className="text-center font-['Inter'] text-[32px] font-bold leading-[1.5] text-[#282A29] mb-3">
            Thanks for signing up!
          </h2>

          {/* Body */}
          <p className="text-center font-['Inter'] text-[16px] font-normal leading-[21.75px] text-[#5D625F] mb-8 max-w-sm">
            {/* Your 30-day Elite trial is now active. We've sent you a welcome
            email with some instructions and information. You can log in now. */}
            Your account is ready. You can log in now.
          </p>

          {/* Log In button */}
          <PrimaryButton onClick={() => navigate(getLogoutRedirect())}>
            Log In
          </PrimaryButton>
        </div>
      </AuthLayout>
    </>
  );
};

export default SignUpSuccess;
